import { commonUtil } from '@/util'
const request = {}

request.createRequest = function (params) {
  // rackInfoList filter

  const productListTmp = [...params.productList]
    .map((ele) => {
      const obj = { ...ele }
      obj.rackNumberList = obj.rackNumberList.filter((rack) => rack.count > 0)
      return obj
    })
    .filter((ele) => ele.rackNumberList.length > 0)

  const productList = productListTmp.map((ele) => {
    const rackInfoList = ele.rackNumberList.map((rack) => {
      return {
        rackNumber: rack.rackNumber,
        quantity: rack.count
      }
    })
    return {
      productId: ele.productId,
      duplicateProductsNumber: ele.duplicateProductsNumber,
      rackInfoList: rackInfoList
    }
  })

  return {
    productList: productList,
    storageId: params.pageInfoData.line1.storageName.value,
    shipDate: params.pageInfoData.line1.shipDate,
    trackingNumber: commonUtil.nullEmptyFormatNull(
      params.pageInfoData.line1.trackingNumber
    ),
    shipDestOrganizationName: commonUtil.nullEmptyFormatNull(
      params.pageInfoData.line2.organizationName
    ),
    shipDestName: commonUtil.nullEmptyFormatNull(
      params.pageInfoData.line2.fullName
    ),
    shipDestAddressCountryId: commonUtil.nullEmptyFormatNull(
      params.pageInfoData.line2.country.value
    ),
    shipDestPostalCode: commonUtil.nullEmptyFormatNull(
      params.pageInfoData.line2.postalCode
    ),

    shipDestRegionId: commonUtil.nullEmptyFormatNull(
      commonUtil.formatRegion(params.pageInfoData.line2.region, true)
    ),
    shipDestRegion: commonUtil.nullEmptyFormatNull(
      commonUtil.formatRegion(params.pageInfoData.line2.region, false)
    ),

    shipDestAddress1: commonUtil.nullEmptyFormatNull(
      params.pageInfoData.line2.address1
    ),
    shipDestAddress2: commonUtil.nullEmptyFormatNull(
      params.pageInfoData.line2.address2
    ),
    shipDestPhoneNumberCountryId: commonUtil.nullEmptyFormatNull(
      params.pageInfoData.line2.phone.countryCode.value
    ),
    shipDestPhoneNumber: commonUtil.nullEmptyFormatNull(
      params.pageInfoData.line2.phone.phoneNumber
    ),
    note: commonUtil.nullEmptyFormatNull(params.pageInfoData.line1.remarks.data)
  }
}
export default { request }
